import { Comment } from "@store/common/comments.model";
import { Action } from "@store/common/actions.model";

import I18nUtils from "@utils/i18n.utils";
import { JobBoard } from "@store/jobBoards";
import { AffiliateLightModel } from "@store/entities/afiliates";
import { CandidateMailType } from "@store/common/mail.model";
import { TwilioAiCall } from "@store/twilioAiCalls";

export enum ApplicationsListEnum {
  TO_BE_PROCESSED = "TO_BE_PROCESSED",
  UNDER_REVIEW = "UNDER_REVIEW",
  TO_BE_CALLED = "TO_BE_CALLED",
  NOT_SELECTED_BY_AI = "NOT_SELECTED_BY_AI",
  NOT_SELECTED = "NOT_SELECTED",
  FIRST_INTERVIEW_PENDING = "FIRST_INTERVIEW_PENDING",
  SECOND_INTERVIEW_PENDING = "SECOND_INTERVIEW_PENDING",
  HIRED = "HIRED",
}

export namespace ApplicationsListEnumFunctions {
  export const label = (list?: ApplicationsListEnum) => {
    return I18nUtils.t(`ads.details.applyTab.lists.${list || "UNKNOWN"}`);
  };

  export const emailTypes: { [key: string]: CandidateMailType } = {
    [ApplicationsListEnum.NOT_SELECTED]: CandidateMailType.REJECTED_APPLICATION,
  };
}

export enum EvaluationStatusEnum {
  LOADING = "LOADING",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export enum AltaysApplicationStatusEnum {
  SENT = "SENT",
  ERROR_CIVILITY = "ERROR_CIVILITY",
  ERROR_LASTNAME = "ERROR_LASTNAME",
  ERROR_FIRSTNAME = "ERROR_FIRSTNAME",
  ERROR_EMAIL = "ERROR_EMAIL",
  ERROR_PHONE = "ERROR_PHONE",
  ERROR_DEGREE = "ERROR_DEGREE",
  ERROR_CV = "ERROR_CV",
  ERROR_ALREADY_SENT = "ERROR_ALREADY_SENT",
  ERROR_OFFER_NOT_FOUND = "ERROR_OFFER_NOT_FOUND",
  ERROR_OTHER = "ERROR_OTHER",
  ERROR_CV_MISSING = "ERROR_CV_MISSING",
  ERROR_CV_INVALID_EXTENSION = "ERROR_CV_INVALID_EXTENSION",
  ERROR_CV_TOO_LARGE = "ERROR_CV_TOO_LARGE",
}

export enum TalentLinkApplicationStatusEnum {
  SENT = "SENT",
  // Validation errors les plus courantes
  FIELD_CANNOT_BE_NULL = "Field cannot be null nor blank",
  REQUIRED_DOCUMENT_MISSING = "Object with answers to a document marked as required is missing",
  FIELD_CANNOT_BE_BLANK = "Field cannot be blank",
  WRONG_ANSWER_FORMAT = "Wrong answer format for question",
  INVALID_ATTACHMENT_ID = "The specified attachment ID does not exist",
  FILE_EXTENSION_MISMATCH = "The extension given in the file name does not match",
  UNSUPPORTED_FILE_FORMAT = "File format is not supported",
  FILE_TOO_LARGE = "File is too large",

  // Erreurs de validation de champs
  MAX_LENGTH_VIOLATION = "Maximum length validation rule violation",
  MIN_LENGTH_VIOLATION = "Minimum length validation rule violation",
  INVALID_EMAIL = "Email is invalid",
  INVALID_URL = "URL is invalid",
  INVALID_PHONE = "Phone number is invalid",
  INVALID_OPTION = "Option not present in structure",
  MISSING_REQUIRED_ANSWER = "Answer to a question marked as required is missing",
}

export enum ExternalSourceEnum {
  METEOJOB = "METEOJOB",
}

export interface AiApplicationEvaluationResponse {
  error: boolean;
  application?: Application;
  erroredApplicationId?: string;
  analysis?: string;
  mark?: number;
  applicationList?: ApplicationsListEnum;
  sentToAltays?: boolean;
  sentToTalentLink?: boolean;
}

export interface AiApplicationInEvaluation extends Omit<Application, "aiEvaluation"> {
  aiEvaluation?: AiApplicationEvaluationResponse;
  aiEvaluationStatus: EvaluationStatusEnum;
}

export interface SendCandidateEmail {
  type?: CandidateMailType;
  text?: string;
  emails?: string[];
  saveText?: boolean;
}

export interface ApplicationsFilters {
  search?: string;
  affiliateIds?: string[];
}

export interface AdApplicationAdInfo {
  id: string;
  name: string;
  description: string;
  reference: string;
  location: string;
  managedByTwinin: boolean;
}

export interface AdApplicationCandidate {
  picture: string;
  fullName: string;
  firstname: string;
  lastname: string;
  email: string;
  city: string;
}

export interface AiEvaluation {
  mark: number;
  analysis: string;
  applicationList: ApplicationsListEnum;
}

export interface ApplicationDetails extends Application {
  comment: Comment[];
  lastActions?: Action[];
}

export interface Application {
  id: string;
  announcement: AdApplicationAdInfo;
  affiliate: AffiliateLightModel;
  name: string;
  date: Date;
  customName?: string;
  commentNumber?: number;
  viewNumber?: number;
  jobboard: JobBoard;
  aioApplicationId?: string;
  candidate?: AdApplicationCandidate;
  linkedinProfileURL?: string;
  list: string;
  inCVTheque?: boolean;
  aiEvaluation?: AiEvaluation;
  twilioAiCall?: TwilioAiCall;
  phoneNumber?: string;
  emailAutoSentAt?: Date;
  altaysApplicationStatus?: AltaysApplicationStatusEnum[];
  externalSource?: ExternalSourceEnum;
  talentLinkApplicationStatus?: TalentLinkApplicationStatusEnum[];
}
